query useNaturalLanguageToJqlQuery($cloudId: ID!, $naturalLanguageInput: String!) {
  jira {
    naturalLanguageToJql(
      cloudId: $cloudId
      input: { naturalLanguageInput: $naturalLanguageInput, iteration: ITERATION_2 }
    ) @optIn(to: "JiraNaturalLanguageToJQL") {
      generatedJQL
      generatedJQLError {
        __typename
      }
    }
  }
}
